// extracted by mini-css-extract-plugin
export default {"container":"AudioPlayer_container__by52C","top":"AudioPlayer_top__dwDRn"};